export function addSpacesBeforeUpperCase(str: string) {
  return str.replace(/([A-Z])/g, ' $1');
}
